export default __webpack_public_path__ + "static/media/banner.47130014.png";